import { Routes, RouterModule } from "@angular/router";
import { AdvancedPreferencesComponent } from "./advanced-preferences/advanced-preferences.component";
import { DigitalIdSettingsComponent } from "./digital-id-settings/digital-id-settings.component";

import { PeriodSettingsComponent, SchoolContactInfoComponent, SuspensionSettingsComponent } from "./index";
import { PeriodSetupComponent } from "./period-setup/period-setup.component";
import { PreferenceSettingsComponent } from "./preferencesettings/preferencesettings.component";
import { SemesterSetupComponent } from "./semester-setup/semester-setup.component";
import { TimeSetupComponent } from "./time-setup/time-setup.component";
import { AuthguardService } from "../master/services";

export const SchoolSettingsRoutes: Routes = [
	{ path: "", redirectTo: "/adminsettings/period", pathMatch: "full" },
	// { path: 'period', data: { title: 'Period Settings' }, component: PeriodSettingsComponent },
	{
		path: "period",
		data: { title: "Period Settings" },
		component: PeriodSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "semester",
		data: { title: "Semester Settings" },
		component: SemesterSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "school",
		data: { title: "School Contact Information" },
		component: SchoolContactInfoComponent,
		canActivate: [AuthguardService],
	},
	// { path: 'tardy', data: { title: 'Time Settings' }, component: TimeSettingsComponent }, //Old
	{
		path: "tardy",
		data: { title: "Time Settings" },
		component: TimeSetupComponent,
		canActivate: [AuthguardService],
	}, //New
	{
		path: "suspension",
		data: { title: "Suspension Settings" },
		component: SuspensionSettingsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "preference",
		data: { title: "Preference Settings" },
		component: PreferenceSettingsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "advancedpreferences",
		data: { title: "Advanced Preference Settings (SU Only)" },
		component: AdvancedPreferencesComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "digitalidsettings",
		data: { title: "Digital ID Settings" },
		component: DigitalIdSettingsComponent,
		canActivate: [AuthguardService],
	},
];
